(function () {
  function initBar(bar) {
    if (bar.dataset.rStickyAtcInit === 'true') return;
    bar.dataset.rStickyAtcInit = 'true';

    var section = bar.closest('[data-section-id]');
    if (!section) return;

    var trigger = section.querySelector('[data-product-form-wrapper] .r-add-buttons');
    var mainQty = section.querySelector('[data-product-form-wrapper] [data-quantity-input]');
    var mainQtyDecrease = section.querySelector('[data-product-form-wrapper] [data-decrease-quantity]');
    var mainQtyIncrease = section.querySelector('[data-product-form-wrapper] [data-increase-quantity]');
    var mainAtc = section.querySelector('[data-product-form-wrapper] [data-add-to-cart]');

    if (!trigger || !mainAtc) return;

    var stickyQty = bar.querySelector('[data-r-sticky-quantity-input]');
    var stickyDecrease = bar.querySelector('[data-r-sticky-quantity-decrease]');
    var stickyIncrease = bar.querySelector('[data-r-sticky-quantity-increase]');
    var stickyButton = bar.querySelector('[data-r-sticky-atc-button]');
    var stickyButtonText = bar.querySelector('[data-r-sticky-atc-text]');

    function getQty(input) {
      var n = parseInt(input.value, 10);
      return isNaN(n) || n < 1 ? 1 : n;
    }

    function syncStickyFromMain() {
      if (!mainQty || !stickyQty) return;
      var v = getQty(mainQty);
      if (stickyQty.value !== String(v)) stickyQty.value = v;
    }

    function pushStickyToMain(value) {
      var n = Math.max(1, parseInt(value, 10) || 1);
      stickyQty.value = n;
      if (!mainQty) return;
      if (mainQty.value !== String(n)) {
        mainQty.value = n;
        mainQty.dispatchEvent(new Event('input', { bubbles: true }));
        mainQty.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (mainQty) {
      syncStickyFromMain();
      mainQty.addEventListener('input', syncStickyFromMain);
      mainQty.addEventListener('change', syncStickyFromMain);
    }

    // Mirror real qty +/- clicks (theme buttons modify the input but may not always fire input)
    if (mainQtyDecrease) mainQtyDecrease.addEventListener('click', function () {
      setTimeout(syncStickyFromMain, 0);
    });
    if (mainQtyIncrease) mainQtyIncrease.addEventListener('click', function () {
      setTimeout(syncStickyFromMain, 0);
    });

    if (stickyDecrease) stickyDecrease.addEventListener('click', function () {
      pushStickyToMain(getQty(stickyQty) - 1);
    });
    if (stickyIncrease) stickyIncrease.addEventListener('click', function () {
      pushStickyToMain(getQty(stickyQty) + 1);
    });
    if (stickyQty) {
      stickyQty.addEventListener('change', function () {
        pushStickyToMain(stickyQty.value);
      });
    }

    if (stickyButton) {
      stickyButton.addEventListener('click', function (e) {
        e.preventDefault();
        if (mainAtc.disabled || stickyButton.classList.contains('loading')) return;
        if (mainQty && stickyQty && mainQty.value !== stickyQty.value) {
          pushStickyToMain(stickyQty.value);
        }
        // Show loading state immediately — MutationObserver fires async and may miss
        // fast AJAX responses, so we add the class synchronously and let the observer
        // remove it when the main button settles.
        stickyButton.classList.add('loading');
        mainAtc.click();
      });
    }

    // Mirror availability + button text from main button on variant change
    function syncButtonState() {
      if (!stickyButton) return;
      stickyButton.disabled = mainAtc.disabled;
      var mainText = mainAtc.querySelector('[data-add-to-cart-text]');
      if (mainText && stickyButtonText) {
        stickyButtonText.innerHTML = mainText.innerHTML;
      }
    }

    section.addEventListener('theme:variant:change', syncButtonState);

    // Mirror loading/success classes from main button so sticky shows spinner + locks out double-clicks
    var mainStateObserver = new MutationObserver(function () {
      if (!stickyButton) return;
      stickyButton.classList.toggle('loading', mainAtc.classList.contains('loading'));
      stickyButton.classList.toggle('has-success', mainAtc.classList.contains('has-success'));
    });
    mainStateObserver.observe(mainAtc, { attributes: true, attributeFilter: ['class'] });

    // Show/hide based on scroll-past state AND whether something is overlaying the page
    // (cart drawer, popdown, modal — all dispatch theme:scroll:lock / :unlock on document).
    // High z-index puts the bar above the cart drawer, so we must hide on lock.
    var shouldShow = false;
    var lockCount = 0;

    function applyVisibility() {
      var visible = shouldShow && lockCount === 0;
      if (visible) {
        if (bar.classList.contains('is-visible')) return;
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
        bar.removeAttribute('inert');
      } else {
        if (!bar.classList.contains('is-visible')) return;
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
        bar.setAttribute('inert', '');
      }
    }
    bar.setAttribute('inert', '');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        shouldShow = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        applyVisibility();
      });
    }, { threshold: 0 });

    observer.observe(trigger);

    document.addEventListener('theme:scroll:lock', function () {
      lockCount++;
      applyVisibility();
    });
    document.addEventListener('theme:scroll:unlock', function () {
      lockCount = Math.max(0, lockCount - 1);
      applyVisibility();
    });
  }

  function initAll() {
    var bars = document.querySelectorAll('[data-r-sticky-atc]');
    bars.forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor section reload support
  document.addEventListener('shopify:section:load', function (e) {
    var bar = e.target.querySelector('[data-r-sticky-atc]');
    if (bar) initBar(bar);
  });
})();
